import { Bot } from 'lucide-react';
import { InfoAlert } from '@/components/info-alert';
import { Button } from '@/components/ui/button';
import { BootstrapCodeDialog } from '@/pages/sandbox/bootstrap-code-dialog';

/**
 * AIT-213 — dismissible dashboard card: copy one snippet into your coding
 * agent (Claude Code, Codex, …) to install the CLI + agent skills and connect
 * the MCP server. Same mint/reveal-on-copy mechanism as Quick Start; the card
 * is a shortcut — Quick Start remains the permanent home of the flow.
 */
export function AgentSetupCard() {
  return (
    <InfoAlert
      icon={Bot}
      dismissKey="hma_agent_setup_card_dismissed"
      actionSlot={
        <BootstrapCodeDialog
          variant="dashboard"
          trigger={<Button size="sm">Copy instructions for your AI</Button>}
        />
      }
    >
      <strong>Set up your AI agent.</strong> Let Claude, ChatGPT, or any AI
      product you use set everything up for you.
    </InfoAlert>
  );
}
